/**
 * OLFARIA product page — the two pieces Dawn's product-info.js does not know about.
 *
 * 1. [data-ol-variant-live] regions (add-to-cart label, mobile sticky bar): after a
 *    variant change Dawn re-renders the section and publishes it on the pub/sub bus; every
 *    live region is copied over from that fresh HTML by id.
 * 2. Thumbnail gallery: a thumb swaps the stage image; a variant with its own image
 *    activates the matching thumb.
 * 3. Mobile sticky bar: shown only while the add-to-cart button sits above the viewport,
 *    i.e. once it has been scrolled past (class ol-stickybar--visible, design-bridge.css).
 */
(() => {
  function watchStickyBar(productInfo) {
    const bar = productInfo.querySelector('.ol-stickybar');
    const button = productInfo.querySelector('button[name="add"]');
    if (!bar || !button || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      bar.classList.toggle('ol-stickybar--visible', scrolledPast);
    }).observe(button);
  }

  document.querySelectorAll('product-info').forEach(watchStickyBar);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('product-info').forEach(watchStickyBar);
  });

  function activateThumb(thumb) {
    const gallery = thumb.closest('.ol-product__gallery');
    const stageImage = gallery && gallery.querySelector('.ol-product__stage img');
    if (!stageImage) return;

    stageImage.srcset = thumb.dataset.srcset || '';
    stageImage.src = thumb.dataset.src;
    // Only the bottle (first thumb) casts the drop shadow.
    stageImage.classList.toggle('ol-stage__img--shadow', thumb.dataset.shadow === 'true');

    gallery.querySelectorAll('[data-ol-thumb]').forEach((other) => {
      other.classList.toggle('ol-thumb--active', other === thumb);
    });
  }

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-ol-thumb]');
    if (thumb) activateThumb(thumb);
  });

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html, variant } }) => {
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    if (!productInfo) return;

    productInfo.querySelectorAll('[data-ol-variant-live]').forEach((region) => {
      const source = html.getElementById(region.id);
      if (source) region.innerHTML = source.innerHTML;
    });

    const image = variant && variant.featured_image;
    if (!image) return;

    const thumb = productInfo.querySelector(`[data-ol-thumb][data-image-id="${image.id}"]`);
    if (thumb) {
      activateThumb(thumb);
      return;
    }

    // No thumbnail strip (single product image): take the stage image from the re-render.
    const stage = productInfo.querySelector('.ol-product__stage');
    const freshStage = html.querySelector('.ol-product__stage');
    if (stage && freshStage) stage.innerHTML = freshStage.innerHTML;
  });
})();
